import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "game-help" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "How to play?"),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" A classic memory. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Memorize the symbols and reveal similar symbols together to remove them from the board until the board is empty. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" A timer will track the time needed to clear the board. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("i", null, "Good luck, have fun!")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Points"),
  /*#__PURE__*/_createElementVNode("div", null, "//TODO: needs to be implemented")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}